import { render } from "./DashLayout.vue?vue&type=template&id=eb7fa588&scoped=true"
import script from "./DashLayout.vue?vue&type=script&lang=js"
export * from "./DashLayout.vue?vue&type=script&lang=js"

import "./DashLayout.vue?vue&type=style&index=0&id=eb7fa588&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb7fa588"]])

export default __exports__